var map = {
	"./alert/template.vue": "1cba",
	"./blocks/template.vue": "0e69",
	"./button/template.vue": "db26",
	"./choice/template.vue": "61da",
	"./field/template.vue": "223f",
	"./select/template.vue": "6351",
	"./test/template.vue": "6906"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "72cb";